
import { defineComponent } from 'vue';
import { Node } from '@antv/x6';

export default defineComponent({
  name: 'ProgressNode',
  inject: ['getNode'],
  data() {
    return {
      percentage: 80
    }
  },
  mounted() {
    const node = (this as any).getNode() as Node
    node.on('change:data', ({ current }) => {
      const { progress } = current;
      this.percentage = progress;
    })
  }
});
